<template>
	<div class='plots-vb-tax'>

		<div class='sc-block'>
			<custom-p-checkbox
				:value='speciesTaxNotAccord'
				@input='onSpeciesTaxNotAccordChanged'
				label='Фактическая таксационная характеристика не соответствует ТО'
				:disabled='speciesTaxNotAccordIsLoading || !actLpoIsDraft'
			/>
		</div>

		<div class='unforested-block'>

			<div v-if='speciesTaxNotAccord' class='grid select-value-block'>

				<div :class='{ "not-match": !isMatch(values["unforested_land"]) }'>
					<span class='select-title'>Не покрытые лесной растительностью земли</span>
					<custom-p-select
						v-model='values["unforested_land"].value'
						:options="info_unforested_land"
						:disabled='catalogsAreLoading || !actLpoIsDraft'
					/>
				</div>
			</div>

			<div class='not-match-block values-btn-row' v-if='notMatchingValues.length'>
				<div>
					<button @click='cancel'>Отмена</button>
					<button @click='save'>Сохранить</button>
				</div>
			</div>

		</div>

		<AddBlock v-if='speciesTaxNotAccord' class='sc-block' />

		<div class='flex sc-block'>

			<div class='fact-species-block species-block' v-if='speciesTaxNotAccord'>
				<div class='title'>Фактический список пород</div>
				<div v-if='!visualSpeciesList.length'>
					<span>Породы не добавлены</span>
				</div>
				<div v-else>

					<div v-for='itemLayer in lpoVisualLayerList'>
						<div class='layer-title-block'>
							<span class='title'>{{ itemLayer.layer == 11 ? `Единичные деревья (${itemLayer.composition.replace('единичные деревья ', '')})`: `Ярус ${itemLayer.layer} (${itemLayer.composition})`}}</span>
							<button :disabled="!actLpoIsDraft" class='remove-layer-btn' @click='removeLayer(itemLayer)'>
								<i class='fa fa-times need-margin-right'></i>
								<span>Удалить ярус</span>
							</button>
						</div>
						
						<table class='species-table'>
							<tr v-for='itemSpecies in lpoVisualLayerSpeciesList(itemLayer)'>
								<td>{{ itemSpecies.coeff }}</td>
								<td>{{ itemSpecies.species_name + ' (' + itemSpecies.name_short + ')' }}</td>
								<td>поколение:</td>
								<td>{{ itemSpecies.gen ? itemSpecies.gen : '-' }}</td>
								<td>возраст:</td>
								<td>{{ itemSpecies.age ? itemSpecies.age : '-' }}</td>
								<td>высота:</td>
								<td>{{ itemSpecies.h ? itemSpecies.h : '-' }}</td>
								<td>диаметр:</td>
								<td>{{ itemSpecies.d ? itemSpecies.d : '-' }}</td>
								<td><button :disabled="!actLpoIsDraft" @click='removeSpecies(itemSpecies)'>
									<i class='fa fa-times'></i>
								</button></td>
							</tr>
						</table>
						<!-- <ul>
							<li v-for='itemSpecies in lpoVisualLayerSpeciesList(itemLayer)'>
								<span>{{ itemSpecies.species_name }}</span>
								<button @click='removeSpecies(itemSpecies)'>удалить</button>
							</li>
						</ul> -->
					</div>

				</div>
			</div>

			<div class='tax-species-block species-block' :class='{ "not-valid": speciesTaxNotAccord }'>
				<div class='title'>Список пород из ТО</div>
				
					<!-- <div v-for='item in taxData'>
						{{ item.species_name }}
					</div> -->

				<div v-if='!taxLayerSpeciesList.length'>
					<span>Породы не добавлены</span>
				</div>
				<div v-else>




					<div v-for='itemLayer in taxLayerList'>
						
						<div class='layer-title-block'>
							<span class='title'>{{ itemLayer.layer == 11 ? `Единичные деревья (${itemLayer.composition.replace('единичные деревья ', '')})`: `Ярус ${itemLayer.layer}(${itemLayer.composition})`  }}</span>
						</div>

						<table class='species-table'>
							<tr v-for='itemSpecies in taxLayerSpeciesList(itemLayer)'>
								<td>{{ itemSpecies.coeff }}</td>
								<td>{{ itemSpecies.species_name + ' (' + itemSpecies.name_short + ')' }}</td>
								<td>поколение:</td>
								<td>{{ itemSpecies.gen ? itemSpecies.gen : '-' }}</td>
								<td>возраст:</td>
								<td>{{ itemSpecies.age ? itemSpecies.age : '-' }}</td>
								<td>высота:</td>
								<td>{{ itemSpecies.h ? itemSpecies.h : '-' }}</td>
								<td>диаметр:</td>
								<td>{{ itemSpecies.d ? itemSpecies.d : '-' }}</td>

							</tr>
						</table>

						<!-- <ul>
							<li v-for='itemSpecies in taxLayerSpeciesList(itemLayer)'>
								{{ itemSpecies.species_name }}
							</li>
						</ul> -->

					</div>

				</div>
			</div>

		</div>

	</div>
</template>

<script>
	import { mapState, mapGetters, mapActions } from 'vuex';

	import AddBlock from './Recount__plotsBvTaxAdd';

	export default {
		name: 'PlotsVbTax',
		components: {
			AddBlock
		},
		data: () => ({
			// notAccords: true,
			catalogsAreLoading: false,

			values: {
				unforested_land: {
					field: 'unforested_land_id',
					inputType: 'select',
					value: null,
					catalog: 'info_unforested_land'
				},
			},
		}),
		computed: {
			// lpo() {
			// 	return this.$store.state.selectedLpo.lpo;
			// },

			...mapState('selectedLpo', {
				lpo: state => state.lpo,
				taxData: state => state.taxData,
				speciesTaxNotAccordIsLoading: state => state.speciesTaxNotAccordIsLoading,
				visualSpeciesList: state => state.visualSpeciesList,
			}),

			...mapState('selectedLpo/recount', {
				plotList: state => state['plotList'],
				vbList: state => state['vbList'],
				vbPct: state => state['vbPct'],
			}),

			...mapState({
				info_unforested_land: state => state.catalogs['info_unforested_land'],
			}),

			...mapGetters('selectedLpo', [
				'speciesTaxNotAccord',
				'taxLayerList',
				'taxLayerSpeciesList',
				'lpoVisualLayerList',
				'lpoVisualLayerSpeciesList'
			]),
			...mapGetters('lpoData', ['actLpoIsDraft'
			]),

			notMatchingValues() {
				const result = [];

				for (const value_name in this.values) {
					if (!this.isMatch(this.values[value_name])) {
						result.push(value_name);
					}
				}

				return result;
			},

		},
		methods: {
			onSpeciesTaxNotAccordChanged(event) {
				// const value = event.target.checked;

				const value = event;

				if (this.vbList.length >= 1 && this.vbList[0].id) {
					const confirmation = confirm('Это удалит все данные ведомости! Продолжить?');
					if (!confirmation) {
						// event.target.checked = this.speciesTaxNotAccord;
						return;
					}
				}
					

				this.toggleSpeciesTaxAccordance(!value).then(res => {
					return this.removeVbList().then(res => {
						this.updateVbList();
						//this.updateVbDamageList();
					});
				}).then(res => {
					return this.updateLpo(this.lpo.lpo_id);
				}).then(res => {
					if (value) {
						return this.getVisualSpecies();
					} else {
						return this.clearVisualSpecies();
					}
					
				}).catch(err => {
					this.$toast.add({severity: 'warn', detail: err.message, life: 10000});
					throw err;
				});
			},

			removeLayer(layer) {
				this.removeLpoVisualLayer(layer).then(res => {
					return this.updateVisualSpecies();
				});
			},

			removeSpecies(species) {
				const payload = {
					layer: species,
					species: species
				};

				this.removeLpoVisualSpecies(payload).then(res => {
					return this.updateVisualSpecies();
				})
			},



			save() {
				const valueList = [];

				for (const value_name of this.notMatchingValues) {
					const inputTypeIsSelect = this.values[value_name].inputType === 'select';

					const value = this.values[value_name].value;

					const temp = {
						field: this.values[value_name].field,
						value: value ? (inputTypeIsSelect ? value.id : value) : null
					};
					valueList.push(temp);
				}

				this.saveLpoValue(valueList).then(res => {
					return this.updateLpo();
				});
			},
			cancel() {
				this.resetValues();
			},

			isMatch(value) {
				if (this.catalogsAreLoading) {
					return true;
				}

				if (value.inputType === 'checkbox') {
					return value.value === (this.lpo[value.field] === 't');
				} else if (value.inputType === 'select') {
					if (!value.value) {
						return this.lpo[value.field] === null;
					} else {
						return value.value.id === this.lpo[value.field];
					}
				}

				return false;
			},

			resetValues() {
				for (let value_name in this.values) {
					const value = this.values[value_name];

					if (value.inputType === 'checkbox') {
						value.value = this.lpo[value.field] === 't';
					} else if (value.inputType === 'select') {

						const temp = this[value.catalog].find(item => {
							return item.id === this.lpo[value.field];
						});
						value.value = temp ? temp : null;

					} else if (value.inputType === 'input') {
						value.value = this.lpo[value.field];
					}
				}
			},

			...mapActions('selectedLpo', [
				'updateLpo',
				'toggleSpeciesTaxAccordance',
				'getVisualSpecies',
				'clearVisualSpecies',
				'removeLpoVisualLayer',
				'updateVisualSpecies',
				'removeLpoVisualSpecies',
				'saveLpoValue',
			]),

			...mapActions('selectedLpo/recount', [
				'updatePlotList',
				'toggleRecount',
				'removeVbList',
				'updateVbList'
			])
		},

		created() {
			const catalogs = [ 'info_unforested_land' ];

			this.catalogsAreLoading = true;
			this.$store.dispatch('loadCatalogs', catalogs).then(res => {
				this.catalogsAreLoading = false;
				this.resetValues();
			});
		}
	};
</script>

<!-- <style scoped src='@/style/flex.css'></style> -->
<!-- <style scoped src='@/style/table.css'></style> -->
<style scoped src='@/style/grid.css'></style>
<style scoped src='@/style/button.css'></style>

<style scoped>

	

	.sc-block {
		margin-bottom: 1rem;
	}

	.tree-list-btn {
		margin-right: 10px;
	}

	.title {
		font-size: 1rem;
		font-weight: bold;
		font-style: italic;
		margin-bottom: 10px;
	}

	.open-btn-block{
		margin-top: 10px;
	}

	.toggle-recount-btn {
		margin-top: 20px;
	}

	strong {
		font-weight: bold;
	}

	.tax-species-block.not-valid {
		border: 1px solid #e6e6e6;
		background-color: #e6e6e6;
		color: #6a6a6a;
	}

	.flex {
		display: flex;
		flex-wrap: wrap;
		gap: 1rem;
	}

	.species-block {
		/*border: 1px solid gray;*/
		padding: 1rem;
		flex: 1;
		/*min-width: 480px;*/
	}

	.species-block .species-table td {
		/*width: 100%;*/
		padding: 0.2rem 0.8rem;
		font-size: 1rem;
	}

	.layer-title-block {
		border-bottom: 1px solid #999;
		padding-bottom: 0.2rem;
		margin-bottom: 0.2rem;
	}
	.layer-title-block::after {
		content: '';
		clear: both;
		display: table;
	}
	.remove-layer-btn {
		float: right;
	}


	.need-margin-right {
		margin-right: 0.8rem;
	}



	/* select unforested */
	.not-match {
		background-color: orange;
	}

	.select-value-block {
		margin-top: 34px;
	}

	.select-title {
		font-weight: bold;
		display: inline-block;
		margin-bottom: 6px;
	}

	.unforested-block {
		margin: 30px 0;
	}

	.values-btn-row > div {
		float: none;
	}
</style>